import { useCallback, useMemo } from "react";
import { ITranslations, TranslationResult } from "./LocalizationProvider";

export const useTranslations = (
  translations: ITranslations["translations"],
) => {
  const t = useCallback(
    (key: string) => {
      // A string may be a path through a translation file, such as "x.y.z". We parse accordingly.
      try {
        const val: TranslationResult = key
          .split(".")
          .reduce(
            (currentTranslationSubtree: TranslationResult, currentKey) => {
              if (!currentTranslationSubtree) {
                throw new Error("no such translation available");
              }
              if (typeof currentTranslationSubtree === "string") {
                throw new Error("no such translation available");
              }
              return currentTranslationSubtree?.[currentKey];
            },
            translations,
          );
        if (typeof val === "string") {
          return val;
        }
        return key;
      } catch {
        console.warn(`No such translation key exists: ${key}`);
        return key;
      }
    },
    [translations],
  );

  return useMemo(() => ({ translations: t }), [t]);
};
